import Vue from 'vue'

export default {
  get () {
    return Vue.$http.get('v1/instance/config')
  }
}
